export default "__VITE_ASSET__hL8SrjdW__"